/**
 *  Help script file
**/
import { clickOutside } from '@/directives/click-outside'

export default {
  name: 'Help',
  mixins: [],
  components: {},
  directives: {
    clickOutside
  },
  props: {
    position: {
      type: String,
      default: 'top-left',
      validator (value) {
        const positions = [
          'top-left',
          'top-right',
          'bottom-left',
          'bottom-right'
        ]
        return positions.indexOf(value) !== -1
      }
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'icon-info-circle.svg',
      required: false
    },
    iconSize: {
      type: String,
      default: '16px',
      required: false
    },
    iconFill: {
      type: String,
      default: '#9397a2',
      required: false
    },
    iconFillOpen: {
      type: String,
      default: '#383d4c',
      required: false
    }
  },
  data () {
    return {
      open: false
    }
  },
  computed: {
    getClasses () {
      return {
        'top-left': this.position === 'top-left',
        'top-right': this.position === 'top-right',
        'bottom-left': this.position === 'bottom-left',
        'bottom-right': this.position === 'bottom-right'
      }
    }
  },
  methods: {
    toggle () {
      this.open = !this.open
    },
    close () {
      this.open = false
    },
    enter (element) {
      const width = getComputedStyle(element).width
      element.style.width = width
      element.style.position = 'absolute'
      element.style.visibility = 'hidden'
      element.style.height = 'auto'
      const height = getComputedStyle(element).height
      element.style.width = null
      element.style.position = null
      element.style.visibility = null
      element.style.height = 0
      // eslint-disable-next-line
      window.getComputedStyle(element).height
      setTimeout(() => { element.style.height = height })
    },

    afterEnter (element) {
      element.style.height = 'auto'
    },

    leave (element) {
      const height = getComputedStyle(element).height
      element.style.height = height
      // eslint-disable-next-line
      window.getComputedStyle(element).height
      setTimeout(() => { element.style.height = 0 })
    }
  }
}
